import _regeneratorRuntime from "D:/work/code/2026/Halov2-Fishery-Upgrade/halov-web/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _createForOfIteratorHelper from "D:/work/code/2026/Halov2-Fishery-Upgrade/halov-web/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper.js";
import _asyncToGenerator from "D:/work/code/2026/Halov2-Fishery-Upgrade/halov-web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/web.atob.js";
import "core-js/modules/web.dom-exception.constructor.js";
import "core-js/modules/web.dom-exception.stack.js";
import "core-js/modules/web.dom-exception.to-string-tag.js";
import { Message, MessageBox } from 'element-ui';
import router from '@/router';
import api from '@/api';
export default {
  namespaced: true,
  actions: {
    /**
     * @description 登录
     * @param {Object} context
     * @param {Object} payload username {String} 用户账号
     * @param {Object} payload password {String} 密码
     * @param {Object} payload route {Object} 登录成功后定向的路由对象 任何 vue-router 支持的格式
     */
    loginByAdmin: function loginByAdmin(_ref) {
      var _arguments = arguments;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var dispatch, _ref2, _ref2$account, account, _ref2$password, password, res, payloadData, tokenUser, operationPermission, _iterator, _step, item, labRes;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              dispatch = _ref.dispatch;
              _ref2 = _arguments.length > 1 && _arguments[1] !== undefined ? _arguments[1] : {}, _ref2$account = _ref2.account, account = _ref2$account === void 0 ? '' : _ref2$account, _ref2$password = _ref2.password, password = _ref2$password === void 0 ? '' : _ref2$password;
              // 清除数据
              localStorage.clear();

              // 关闭所有Tab（切换用户的时候Tab会保留之前信息）
              _context.next = 5;
              return dispatch('d2admin/page/closeAll', true, {
                root: true
              });
            case 5:
              _context.next = 7;
              return api.loginByAdmin({
                account: account,
                password: password,
                readRoles: true
              });
            case 7:
              res = _context.sent;
              // 获取JWT载荷信息
              payloadData = JSON.parse(decodeURIComponent(escape(window.atob(res.data.token.replace(/-/g, '+').replace(/_/g, '/').split('.')[1])))); // 获取Token中用户基本信息
              tokenUser = JSON.parse(payloadData.User); // 设置用户ID
              localStorage.setItem('userId', tokenUser.id);
              localStorage.setItem('userInfo', JSON.stringify(tokenUser));
              localStorage.setItem('userData', JSON.stringify(res.data));
              console.log('tokenUser', res.data, res.data.nickname);
              // 设置用户昵称
              localStorage.setItem('userNickname', res.data.nickname);
              // 设置用户头像
              localStorage.setItem('userImage', tokenUser.image || 'https://tvax4.sinaimg.cn/crop.0.0.1125.1125.180/47644b1aly8fplxkswy29j20v90v976g.jpg');
              // 设置用户Token
              localStorage.setItem('token', res.data.token);
              // 设置用户Token过期时间
              localStorage.setItem('tokenExp', payloadData.exp);
              // 设置用户Refresh Token
              localStorage.setItem('refreshToken', tokenUser.refreshToken);
              // 设置最后刷新时间
              localStorage.setItem('lastRefreshTokenTime', new Date().getTime());
              // 设置用户菜单
              localStorage.setItem('menu', JSON.stringify(res.data.userMenus));
              // 设置菜单权限
              localStorage.setItem('userPerms', JSON.stringify(res.data.userPerms));
              localStorage.setItem('asideMenu', '');
              // 操作按钮权限
              operationPermission = {};
              _iterator = _createForOfIteratorHelper(res.data.userPerms);
              try {
                for (_iterator.s(); !(_step = _iterator.n()).done;) {
                  item = _step.value;
                  operationPermission[item] = true;
                }
              } catch (err) {
                _iterator.e(err);
              } finally {
                _iterator.f();
              }
              localStorage.setItem('operationPermission', JSON.stringify(operationPermission));
              localStorage.setItem('accountCategory', res.data.category);
              if (!(res.data.category === 'Business')) {
                _context.next = 36;
                break;
              }
              _context.next = 31;
              return api.labDetail(res.data.labId);
            case 31:
              labRes = _context.sent;
              // 所属企业ID
              localStorage.setItem('labId', res.data.labId);
              localStorage.setItem('labName', res.data.labName);
              localStorage.setItem('labInfo', JSON.stringify(res.data));
              // 大屏演示模式
              localStorage.setItem('showSimulate', labRes.data.showSimulate);
            case 36:
              _context.next = 38;
              return dispatch('d2admin/user/set', {
                name: res.data.nickname
              }, {
                root: true
              });
            case 38:
              _context.next = 40;
              return dispatch('load');
            case 40:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    loginByPhone: function loginByPhone(_ref3) {
      var _arguments2 = arguments;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var dispatch, _ref4, _ref4$phone, phone, _ref4$captcha, captcha, res, payloadData, tokenUser, operationPermission, _iterator2, _step2, item;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              dispatch = _ref3.dispatch;
              _ref4 = _arguments2.length > 1 && _arguments2[1] !== undefined ? _arguments2[1] : {}, _ref4$phone = _ref4.phone, phone = _ref4$phone === void 0 ? '' : _ref4$phone, _ref4$captcha = _ref4.captcha, captcha = _ref4$captcha === void 0 ? '' : _ref4$captcha;
              // 清除数据
              localStorage.clear();

              // 关闭所有Tab（切换用户的时候Tab会保留之前信息）
              _context2.next = 5;
              return dispatch('d2admin/page/closeAll', true, {
                root: true
              });
            case 5:
              _context2.next = 7;
              return api.loginByPhone({
                phone: phone,
                captcha: captcha
              });
            case 7:
              res = _context2.sent;
              // 判断用户类别，非管理员用户不允许登录总后台
              // if (res.data.category !== 'Admin') {
              //   Message.error('无权限')
              //   return
              // }
              // 获取JWT载荷信息
              payloadData = JSON.parse(decodeURIComponent(escape(window.atob(res.data.token.replace(/-/g, '+').replace(/_/g, '/').split('.')[1])))); // 获取Token中用户基本信息
              tokenUser = JSON.parse(payloadData.User); // 设置用户ID
              localStorage.setItem('userId', tokenUser.id);
              localStorage.setItem('userInfo', JSON.stringify(tokenUser));
              localStorage.setItem('userData', JSON.stringify(res.data));
              // 设置用户昵称
              localStorage.setItem('userNickname', res.data.nickname || '请设置昵称');
              // 设置用户头像
              localStorage.setItem('userImage', tokenUser.image || 'https://tvax4.sinaimg.cn/crop.0.0.1125.1125.180/47644b1aly8fplxkswy29j20v90v976g.jpg');
              // 设置用户Token
              localStorage.setItem('token', res.data.token);
              // 设置用户Token过期时间
              localStorage.setItem('tokenExp', payloadData.exp);
              // 设置用户Refresh Token
              localStorage.setItem('refreshToken', tokenUser.refreshToken);
              // 设置最后刷新时间
              localStorage.setItem('lastRefreshTokenTime', new Date().getTime());
              // 设置用户菜单
              localStorage.setItem('menu', JSON.stringify(res.data.userMenus));
              // 设置菜单权限
              localStorage.setItem('userPerms', JSON.stringify(res.data.userPerms));
              localStorage.setItem('asideMenu', null);
              // 操作按钮权限
              operationPermission = {};
              _iterator2 = _createForOfIteratorHelper(res.data.userPerms);
              try {
                for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
                  item = _step2.value;
                  operationPermission[item] = true;
                }
              } catch (err) {
                _iterator2.e(err);
              } finally {
                _iterator2.f();
              }
              localStorage.setItem('operationPermission', JSON.stringify(operationPermission));

              // 向 vuex 中增加用户信息
              _context2.next = 28;
              return dispatch('d2admin/user/set', {
                name: res.data.nickname
              }, {
                root: true
              });
            case 28:
              _context2.next = 30;
              return dispatch('load');
            case 30:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    loginByWxCode: function loginByWxCode(_ref5) {
      var _arguments3 = arguments;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var dispatch, code, res, payloadData, tokenUser, operationPermission, _iterator3, _step3, item;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              dispatch = _ref5.dispatch;
              code = _arguments3.length > 1 && _arguments3[1] !== undefined ? _arguments3[1] : '';
              _context3.next = 4;
              return api.wxWebLogin(code);
            case 4:
              res = _context3.sent;
              if (res.data.id) {
                _context3.next = 8;
                break;
              }
              setTimeout(function () {
                window.parent.location.href = 'https://gy.rich-link.cn/login?msg=暂未绑定用户！';
              }, 1000);
              return _context3.abrupt("return", '暂未绑定用户！');
            case 8:
              // 清除数据
              localStorage.clear();

              // 关闭所有Tab（切换用户的时候Tab会保留之前信息）
              _context3.next = 11;
              return dispatch('d2admin/page/closeAll', true, {
                root: true
              });
            case 11:
              // 判断用户类别，非管理员用户不允许登录总后台
              // if (res.data.category !== 'Admin') {
              //   Message.error('无权限')
              //   return
              // }
              // 获取JWT载荷信息
              payloadData = JSON.parse(decodeURIComponent(escape(window.atob(res.data.token.replace(/-/g, '+').replace(/_/g, '/').split('.')[1])))); // 获取Token中用户基本信息
              tokenUser = JSON.parse(payloadData.User); // 设置用户ID
              localStorage.setItem('userId', tokenUser.id);
              localStorage.setItem('userInfo', JSON.stringify(tokenUser));
              localStorage.setItem('userData', JSON.stringify(res.data));
              // 设置用户昵称
              localStorage.setItem('userNickname', res.data.nickname || '请设置昵称');
              // 设置用户头像
              localStorage.setItem('userImage', tokenUser.image || 'https://tvax4.sinaimg.cn/crop.0.0.1125.1125.180/47644b1aly8fplxkswy29j20v90v976g.jpg');
              // 设置用户Token
              localStorage.setItem('token', res.data.token);
              // 设置用户Token过期时间
              localStorage.setItem('tokenExp', payloadData.exp);
              // 设置用户Refresh Token
              localStorage.setItem('refreshToken', tokenUser.refreshToken);
              // 设置最后刷新时间
              localStorage.setItem('lastRefreshTokenTime', new Date().getTime());
              // 设置用户菜单
              localStorage.setItem('menu', JSON.stringify(res.data.userMenus));
              // 设置菜单权限
              localStorage.setItem('userPerms', JSON.stringify(res.data.userPerms));
              localStorage.setItem('asideMenu', null);
              localStorage.setItem('labId', res.data.labId);
              // 操作按钮权限
              operationPermission = {};
              _iterator3 = _createForOfIteratorHelper(res.data.userPerms);
              try {
                for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
                  item = _step3.value;
                  operationPermission[item] = true;
                }
              } catch (err) {
                _iterator3.e(err);
              } finally {
                _iterator3.f();
              }
              localStorage.setItem('operationPermission', JSON.stringify(operationPermission));

              // 向 vuex 中增加用户信息
              _context3.next = 32;
              return dispatch('d2admin/user/set', {
                name: res.data.nickname
              }, {
                root: true
              });
            case 32:
              _context3.next = 34;
              return dispatch('load');
            case 34:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))();
    } // Token 刷新
    ,
    refreshToken: function refreshToken() {
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        var token, lastRefreshTokenTime, nowTime, refreshToken, tokenExpTime, res, payloadData, tokenUser;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              console.log('Token 刷新 refreshToken!!!!!!!');
              // 获取Token
              token = localStorage.getItem('token') || ''; // 如果没有Token则去登录
              if (token) {
                _context4.next = 6;
                break;
              }
              router.replace('/login');
              _context4.next = 38;
              break;
            case 6:
              // 获取上次刷新时间
              lastRefreshTokenTime = localStorage.getItem('lastRefreshTokenTime') || 0;
              if (!(lastRefreshTokenTime <= 0)) {
                _context4.next = 11;
                break;
              }
              // 如果没有最后一次刷新时间则去登录
              router.replace('/login');
              _context4.next = 38;
              break;
            case 11:
              // 获取当前时间
              nowTime = new Date().getTime(); // 判断当前是否超过1小时未刷新去登录
              if (!(nowTime - lastRefreshTokenTime > 1 * 60 * 60 * 1000)) {
                _context4.next = 17;
                break;
              }
              console.log('超过1小时未刷新去登录!!!!!!!', nowTime - lastRefreshTokenTime);
              router.replace('/login');
              _context4.next = 38;
              break;
            case 17:
              // 获取刷新Token
              refreshToken = localStorage.getItem('refreshToken') || ''; // 判断是否存在刷新Token
              if (refreshToken) {
                _context4.next = 22;
                break;
              }
              router.replace('/login');
              _context4.next = 38;
              break;
            case 22:
              // 获取Token失效时间
              tokenExpTime = localStorage.getItem('tokenExp') * 1000 || 0;
              console.log('获取Token失效时间', tokenExpTime);

              // 判断Token有效期 是否将要到期 (当前时间 - Token有效期 < 10分钟)
              if (!(tokenExpTime - nowTime < 10 * 60 * 1000)) {
                _context4.next = 38;
                break;
              }
              // 获取新Token
              console.log('真的去刷了！！！！获取新token！！！！！！！！');
              _context4.next = 28;
              return api.refreshToken({
                refreshToken: refreshToken
              });
            case 28:
              res = _context4.sent;
              // 获取JWT载荷信息
              payloadData = JSON.parse(decodeURIComponent(escape(window.atob(res.data.replace(/-/g, '+').replace(/_/g, '/').split('.')[1])))); // 获取Token中用户基本信息
              tokenUser = JSON.parse(payloadData.User); // 设置用户ID
              localStorage.setItem('userId', tokenUser.id);
              // 设置用户昵称
              localStorage.setItem('userNickname', res.data.nickname || '请设置昵称');
              // 设置用户头像
              localStorage.setItem('userImage', tokenUser.image || 'https://tvax4.sinaimg.cn/crop.0.0.1125.1125.180/47644b1aly8fplxkswy29j20v90v976g.jpg');
              // 设置用户Token
              localStorage.setItem('token', res.data);
              // 设置用户Token过期时间
              localStorage.setItem('tokenExp', payloadData.exp);
              // 设置用户Refresh Token
              localStorage.setItem('refreshToken', tokenUser.refreshToken);
              // 设置最后刷新时间
              localStorage.setItem('lastRefreshTokenTime', nowTime);
              // 设置用户菜单
              // localStorage.setItem('menu', JSON.stringify(res.data.userMenus))
            case 38:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }))();
    }
    /**
     * @description 退出用户并返回登录页面
     * @param {Object} context
     * @param {Object} payload confirm {Boolean} 是否需要确认
     */
    ,
    logout: function logout(_ref6) {
      var commit = _ref6.commit,
        dispatch = _ref6.dispatch;
      var _ref7 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        _ref7$confirm = _ref7.confirm,
        confirm = _ref7$confirm === void 0 ? false : _ref7$confirm;
      /**
       * @description 退出
       */
      function logout() {
        return _logout.apply(this, arguments);
      } // 判断是否需要确认
      function _logout() {
        _logout = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
          return _regeneratorRuntime().wrap(function _callee5$(_context5) {
            while (1) switch (_context5.prev = _context5.next) {
              case 0:
                // 清除数据
                localStorage.clear();

                // 清空 vuex 用户信息
                _context5.next = 3;
                return dispatch('d2admin/user/set', {}, {
                  root: true
                });
              case 3:
                // 跳转路由
                router.push({
                  name: 'login'
                });
              case 4:
              case "end":
                return _context5.stop();
            }
          }, _callee5);
        }));
        return _logout.apply(this, arguments);
      }
      if (confirm) {
        commit('d2admin/gray/set', true, {
          root: true
        });
        MessageBox.confirm('确定要退出当前用户吗', '退出用户', {
          type: 'warning'
        }).then(function () {
          commit('d2admin/gray/set', false, {
            root: true
          });
          logout();
        }).catch(function () {
          commit('d2admin/gray/set', false, {
            root: true
          });
          Message({
            message: '取消退出操作'
          });
        });
      } else {
        logout();
      }
    }
    /**
     * @description 用户登录后从持久化数据加载一系列的设置
     * @param {Object} context
     */
    ,
    load: function load(_ref8) {
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
        var dispatch;
        return _regeneratorRuntime().wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              dispatch = _ref8.dispatch;
              _context6.next = 3;
              return dispatch('d2admin/user/load', null, {
                root: true
              });
            case 3:
              _context6.next = 5;
              return dispatch('d2admin/theme/load', null, {
                root: true
              });
            case 5:
              _context6.next = 7;
              return dispatch('d2admin/transition/load', null, {
                root: true
              });
            case 7:
              _context6.next = 9;
              return dispatch('d2admin/page/openedLoad', null, {
                root: true
              });
            case 9:
              _context6.next = 11;
              return dispatch('d2admin/menu/asideLoad', null, {
                root: true
              });
            case 11:
              _context6.next = 13;
              return dispatch('d2admin/size/load', null, {
                root: true
              });
            case 13:
              _context6.next = 15;
              return dispatch('d2admin/color/load', null, {
                root: true
              });
            case 15:
            case "end":
              return _context6.stop();
          }
        }, _callee6);
      }))();
    }
  }
};